<template>
  <div class="system-dic-container layout-padding">
    <el-card shadow="hover" class="layout-padding-auto">
      <div class="system-user-search mb15">
        <el-input
          v-model="queryData.SearchValue"
          size="small"
          placeholder="请输入"
          style="max-width: 180px"
        >
        </el-input>
        <el-button
          size="small"
          type="primary"
          class="ml10"
          @click="queryTableData"
        >
          <el-icon>
            <ele-Search />
          </el-icon>
          查询
        </el-button>
      </div>
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column
          prop="Name"
          label="持卡人姓名"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="IDCard"
          label="身份证"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Phone"
          label="联系电话"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Green_card_nubmer"
          label="绿卡卡号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Application_date"
          label="发行时间"
          show-overflow-tooltip
          width="160"
        ></el-table-column>

        <el-table-column label="操作" width="160" align="center">
          <template #default="scope">
            <!-- <el-button
              v-if="scope.row.State == 0"
              size="small"
              type="text"
              @click="onChangeStateHandle(scope.row, 1)"
            >
              启用
            </el-button> -->
            <el-button
              size="small"
              type="text"
              @click="onChangeStateHandle(scope.row, 0)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        class="mt15"
        :pager-count="5"
        :page-sizes="[10, 20, 30]"
        v-model:current-page="queryData.page"
        background
        v-model:page-size="queryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import {
  GetTalenGreenCardByPage,
  UpdateTalentgreencardState,
} from "@/api/talentGreenCard/index";

export default {
  name: "activity-list",
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        page: 1,
        pageSize: 10,
        SearchValue: "",
      },
    };
  },
  methods: {
    queryTableData() {
      let param = {
        page: this.queryData.page,
        intPageSize: this.queryData.pageSize,
        SearchValue: this.queryData.SearchValue,
      };
      this.HttpQueryBlogList(param);
    },
    onHandleSizeChange(val) {
      this.queryData.pageSize = val;
      this.queryTableData();
    },
    onHandleCurrentChange(val) {
      this.queryData.page = val;
      this.queryTableData();
    },
    //Http查询列表数据
    async HttpQueryBlogList(param) {
      this.loading = true;
      const res = await GetTalenGreenCardByPage(param);
      this.loading = false;
      if (res.data.status == 200) {
        let raw = res.data.response;

        this.total = raw.dataCount;
        this.tableData = raw.data;
      } else {
        this.$message.error(res.data.msg);
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    async HttpChangeState(param) {
      const response = await UpdateTalentgreencardState(param);
      let res = response.data || {};
      if (res.status == 200) {
        this.queryTableData();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    onChangeStateHandle(row, state) {
      this.HttpChangeState({ Id: row.Id, state: state });
    },
  },

  mounted() {
    this.queryTableData();
  },
};
</script>

<style scoped></style>
